/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for notification groups.
 * @export
 * @interface NotificationGroupCreateRequest
 */
export interface NotificationGroupCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof NotificationGroupCreateRequest
     */
    owner?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationGroupCreateRequest
     */
    name: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof NotificationGroupCreateRequest
     */
    channels?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof NotificationGroupCreateRequest
     */
    people?: Array<number>;
}

/**
 * Check if a given object implements the NotificationGroupCreateRequest interface.
 */
export function instanceOfNotificationGroupCreateRequest(value: object): value is NotificationGroupCreateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function NotificationGroupCreateRequestFromJSON(json: any): NotificationGroupCreateRequest {
    return NotificationGroupCreateRequestFromJSONTyped(json, false);
}

export function NotificationGroupCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationGroupCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'owner': json['owner'] === undefined ? undefined : json['owner'] === null ? null : json['owner'],
        'name': json['name'],
        'channels': json['channels'] == null ? undefined : json['channels'],
        'people': json['people'] == null ? undefined : json['people'],
    };
}

export function NotificationGroupCreateRequestToJSON(json: any): NotificationGroupCreateRequest {
    return NotificationGroupCreateRequestToJSONTyped(json, false);
}

export function NotificationGroupCreateRequestToJSONTyped(value?: NotificationGroupCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner': value['owner'],
        'name': value['name'],
        'channels': value['channels'],
        'people': value['people'],
    };
}

